// extracted by mini-css-extract-plugin
export default {"help":"styles_help__nNgje","title":"styles_title__eG9OZ","text":"styles_text__CX2xr","sbp-logo":"styles_sbp-logo__1BiUz","button-wrapper":"styles_button-wrapper__Bt3Mj"};